// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';
import { dispatch } from '../index';

// ----------------------------------------------------------------------

const initialState = {
    error: null,
    brands: [],
    subindustries: [],
    industries: []
};

const slice = createSlice({
    name: 'basedata',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        // GET BRANDS
        getBrandsSuccess(state, action) {
            state.brands = action.payload.brandList;
            state.count = action.payload.total;
        },

        // GET SUBINDUSTRYS
        getSubindustriesSuccess(state, action) {
            state.subindustries = action.payload.subindustryList;
            state.count = action.payload.total;
        },

        // GET INDUSTRYS
        getIndustriesSuccess(state, action) {
            state.industries = action.payload.industryList;
            state.count = action.payload.total;
        }
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getBrands(data) {
    return async () => {
        try {
            const response = await axios.post('/api/brand/list', data,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            }
            );
            dispatch(slice.actions.getBrandsSuccess(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getSubindustries(data) {
    return async () => {
        try {
            const response = await axios.post('/api/subindustry/list', data,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            }
            );
            dispatch(slice.actions.getSubindustriesSuccess(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getIndustries(data) {
    return async () => {
        try {
            const response = await axios.post('/api/industry/list', data,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            }
            );
            dispatch(slice.actions.getIndustriesSuccess(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
